import { withStorageClient as clientLibWithStorageClient } from "@arena-active/client-lib";

export const withStorageClient = clientLibWithStorageClient;
